import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "highlight", "className", "style", "inline", "colorVariant"];
var _variantClassNames;
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _values from 'lodash/values';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import styles from './content.module.scss';
var colorVariants = {
  BLACK: 'black',
  WHITE: 'white',
  GREY: 'grey'
};
var variantClassNames = (_variantClassNames = {}, _defineProperty(_variantClassNames, colorVariants.BLACK, {
  highlight: styles.blackHighlightContent,
  normal: styles.blackNormalContent
}), _defineProperty(_variantClassNames, colorVariants.WHITE, {
  highlight: styles.whiteHighlightContent,
  normal: styles.whiteNormalContent
}), _defineProperty(_variantClassNames, colorVariants.GREY, {
  highlight: styles.greyHighlightContent,
  normal: styles.greyNormalContent
}), _variantClassNames);
var getContentClass = function getContentClass(highlight, colorVariant) {
  var currentColorVariantClassNames = variantClassNames[colorVariant] || EMPTY_OBJECT;
  if (highlight) return currentColorVariantClassNames.highlight;
  return currentColorVariantClassNames.normal;
};
var Content = function Content(props) {
  var children = props.children,
    highlight = props.highlight,
    className = props.className,
    style = props.style,
    inline = props.inline,
    colorVariant = props.colorVariant,
    extraProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    style: style,
    className: cx(getContentClass(highlight, colorVariant), className, {
      'd-inline': inline
    })
  }, extraProps), children);
};
Content.COLOR_VARIANTS = colorVariants;
Content.propTypes = {
  children: PropTypes.node,
  highlight: PropTypes.bool,
  inline: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  colorVariant: PropTypes.oneOf(_values(colorVariants))
};
Content.defaultProps = {
  children: undefined,
  highlight: false,
  inline: false,
  className: EMPTY_STRING,
  style: EMPTY_OBJECT,
  colorVariant: colorVariants.BLACK
};
export default Content;